/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ metres: NonNullable<unknown> }} Workout_Detail_MetresInputs */

const en_us2_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const pt_br2_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const es_419_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const pt_pt2_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const fr_fr2_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const de_de2_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const it_it2_workout_detail_metres = /** @type {(inputs: Workout_Detail_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

/**
* | output |
* | --- |
* | "{metres} m" |
*
* @param {Workout_Detail_MetresInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_detail_metres = /** @type {((inputs: Workout_Detail_MetresInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Detail_MetresInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_detail_metres(inputs)
	if (locale === "es-419") return es_419_workout_detail_metres(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_detail_metres(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_detail_metres(inputs)
	if (locale === "de-DE") return de_de2_workout_detail_metres(inputs)
	if (locale === "it-IT") return it_it2_workout_detail_metres(inputs)
	return en_us2_workout_detail_metres(inputs)
});
export { workout_detail_metres as "workout.detail_metres" }